import React, {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import {OrderContext} from "../../../contexts/OrderContext";
import {MenuActionButtonStyles} from "../styles";
import {
    GamesPageActionButton,
    ProfilePageActionButton,
    ServicesPageActionButton,
    WaiterCallButton
} from "./MenuActionsComponents";
import {View} from "react-native";

export default function OrderProgressActionView(props: any) {

    const appConfigContext = useContext(AppConfigContext);
    const color = Colors.instanceNoServerColor(appConfigContext.theme, appConfigContext.color);
    const order = useContext(OrderContext);

    const lStyle = MenuActionButtonStyles(color);

    const actionButtonSet = [];

    switch (order.order?.type) {
        case "table":
            if (props.optionsAccess.services)
                actionButtonSet.push(<ServicesPageActionButton key={0} grow={25} color={"red"}/>);
            if (props.optionsAccess.waiter_call)
                actionButtonSet.push(<WaiterCallButton key={1} grow={25} color={"yellow"}/>);
            if (props.optionsAccess.games)
                actionButtonSet.push(<GamesPageActionButton key={2} grow={25} color={"green"}/>);
            break;
        case "outside":
        case "takeaway":
            actionButtonSet.push(<ProfilePageActionButton key={0} grow={25} color={"red"}/>);
            if (props.optionsAccess.games)
                actionButtonSet.push(<GamesPageActionButton key={1} grow={25} color={"green"}/>);
            break;
    }

    return <View style={lStyle.buttonContainer}>

        {actionButtonSet}

    </View>
}